import * as React from "react";
import { FormComponentProps } from "antd/lib/form";
import { TTranslate } from "../../../service/locale/TranslationService";
import SystemParameterForm from "./SystemParameterForm";

export interface State {}

export interface CreateSystemParameterFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  codebooks: any[];
}

class CreateSystemParameterForm extends React.Component<
  CreateSystemParameterFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let newSystemParameter = null;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newSystemParameter = values;
        }
      });
      return newSystemParameter;
    });
  }

  render() {
    const { translate } = this.props;
    const { getFieldDecorator, getFieldValue } = this.props.form;

    return (
      <SystemParameterForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        getFieldValue={getFieldValue}
      />
    );
  }
}

export default CreateSystemParameterForm;
